import { Injectable } from '@angular/core';
import { SalesWstoPrintingQuery, SalesWstoPrintingQueryHandlerBase } from '@skylab-shared/business';

import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SalesWstoPrintingQuery)
@Wrapper(SalesWstoPrintingQueryHandlerBase)
export class SalesWstoPrintingQueryHandler {
    public constructor(
        http: Http
    ) { }
}
